import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const formatDate = (era: number): string => {
  return dayjs.unix(era).format('DD.MM.YYYY, hh:mm');
};
